import { createLazyComponent, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "InfoBarView" */ './lazyIndex')
);

export const InfoBar = createLazyComponent(lazyModule, m => m.InfoBar);

export const InfoBarAnnouncements = createLazyComponent(lazyModule, m => m.InfoBarAnnouncements);

export const InfoBarMessage = createLazyComponent(lazyModule, m => m.InfoBarMessage);

export const InfoBarMessageInfoIcon = createLazyComponent(
    lazyModule,
    m => m.InfoBarMessageInfoIcon
);

export const InfoBarMessagePart = createLazyComponent(lazyModule, m => m.InfoBarMessagePart);

export const InfoBarMessageWithCalloutAction = createLazyComponent(
    lazyModule,
    m => m.InfoBarMessageWithCalloutAction
);

export const InfoBarMessageWithCustomAction = createLazyComponent(
    lazyModule,
    m => m.InfoBarMessageWithCustomAction
);

export const InfoBarMessageWithOptionsAction = createLazyComponent(
    lazyModule,
    m => m.InfoBarMessageWithOptionsAction
);

export const InfoBarMessageWithShowDetailsAction = createLazyComponent(
    lazyModule,
    m => m.InfoBarMessageWithShowDetailsAction
);

export const InfobarShowHideDetailsPart = createLazyComponent(
    lazyModule,
    m => m.InfobarShowHideDetailsPart
);
export { InfobarShowHideDetailsPartProps } from './components/InfoBarComponentProps';
